import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";

import { Icon } from "@/components/atoms/Icon";
import { StripTabBar } from "@/components/molecules/StripTabBar";
import { Button } from "@/components/ui/button";
import { Typography } from "@/components/ui/typography";

import { type BudgetViewTab, useBudgetViewStore } from "./BudgetView.store";

const TABS = [
  { id: "month", label: "Month" },
  { id: "plan", label: "Plan" },
  { id: "wishlist", label: "Wishlist" },
];

/**
 * The Budget view's bar: its tabs - the month, the plan each month is held
 * to, and the wishlist it puts by for - and, for the month, which one it is.
 */
export function BudgetViewSubnav() {
  const tab = useBudgetViewStore((state) => state.tab);
  const setTab = useBudgetViewStore((state) => state.setTab);
  const month = useBudgetViewStore((state) => state.month);
  const setMonth = useBudgetViewStore((state) => state.setMonth);

  const shift = (by: number) => {
    const [year, number] = month.split("-").map(Number);
    const next = new Date(year, number - 1 + by, 1);
    setMonth(
      `${next.getFullYear()}-${String(next.getMonth() + 1).padStart(2, "0")}-01`,
    );
  };

  return (
    <div className="flex items-center gap-2 w-full min-w-0">
      <StripTabBar
        tabs={TABS}
        selectedTabId={tab}
        onTabChange={(picked) => setTab(picked as BudgetViewTab)}
      />
      {tab === "month" && (
        <div className="ml-auto flex items-center gap-1 shrink-0">
          <Button
            variant="ghost"
            size="icon-sm"
            aria-label="The month before"
            onClick={() => shift(-1)}
          >
            <Icon ReactIcon={ChevronLeftIcon} size="xs" />
          </Button>
          <Typography
            level="title-sm"
            data-testid="budget-month"
            className="min-w-30 text-center"
          >
            {new Date(`${month}T12:00:00`).toLocaleDateString(undefined, {
              month: "long",
              year: "numeric",
            })}
          </Typography>
          <Button
            variant="ghost"
            size="icon-sm"
            aria-label="The month after"
            onClick={() => shift(1)}
          >
            <Icon ReactIcon={ChevronRightIcon} size="xs" />
          </Button>
        </div>
      )}
    </div>
  );
}
